import { useEffect } from 'react'

import { Dropdown, Option, OptionGroup, Text } from '@joor/design-system'
import { CSSObject } from 'styled-components'

import { OptionContainer } from 'modals/ReassignConnectionsModal/ReassignConnectionsModal.ui'

import IDs from '../../reassignConnectionsModal.ids'
import messages from '../../reassignConnectionsModal.messages'
import useStore from '../../store/useReassignConnectionsStore'

interface SourceUserDropdownProps {
  options: OptionGroup[]
  isLoading: boolean
  selectedUserId?: string
}

const SourceUserDropdown = ({
  options: optionGroups,
  isLoading,
  selectedUserId,
}: SourceUserDropdownProps): JSX.Element => {
  const sourceUser = useStore((state) => state.sourceUser)
  const setSourceUser = useStore((state) => state.setSourceUser)
  const salesReps = useStore((state) => state.salesReps)

  useEffect(() => {
    if (!salesReps.length && !sourceUser) return
    const selectedUser = salesReps.find(
      (accUser) => accUser.user.id === selectedUserId,
    )
    if (selectedUser) {
      setSourceUser({ sourceUser: selectedUser })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesReps, sourceUser, setSourceUser])

  const selectedSourceUserOption = [
    ...optionGroups[0].options,
    ...optionGroups[1].options,
  ].find((option) => option.value === sourceUser?.id)

  return (
    <Dropdown
      id={IDs.SourceUserDropdown}
      testId={IDs.SourceUserDropdown}
      label={messages.selectSalesRep}
      options={optionGroups}
      isLoading={isLoading}
      isDisabled={!!selectedUserId || isLoading}
      value={selectedSourceUserOption}
      onSelect={({ selected }: { selected: Option }) => {
        const selectedUser = salesReps.find((rep) => rep.id === selected.value)
        if (!selectedUser) return
        setSourceUser({ sourceUser: selectedUser })
      }}
      styles={{
        groupHeading: (b: CSSObject) => ({
          ...b,
          marginLeft: '-8px',
        }),
        option: (b: CSSObject) => ({ ...b, padding: '8px 24px' }),
      }}
      maxOptionsToShow={6}
      formatOptionLabel={(option: Option & { numberConnections?: number }) => (
        <OptionContainer>
          <span>{option.label}</span>
          <Text fontSize="small" color="primary-500">
            {option.numberConnections}{' '}
            {option.numberConnections === 1
              ? messages.connection
              : messages.connections}
          </Text>
        </OptionContainer>
      )}
    />
  )
}

export default SourceUserDropdown
